<template>
	<div class="container page">
		<van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			<template #right>
				<span class="nav-right"
					@click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
			</template>
		</van-nav-bar>
		<div class="main">
			<div class="withdrawMoney">
				<span>{{$t("withdraw.with_money")}} ({{$t("reservation.unit")}})</span>
				<div class="money">
					<div class="moneyNumber">
						<span class="moneyType">TWD</span>
						<van-field v-model="withdraw_money" type="number" />
					</div>
					<span class="all" @click="allMoeny()">{{$t("index.all")}}</span>
				</div>
				<div class="information">
					<div class="description">
						<van-popover v-model="showPopover" trigger="click">
							<div class="popover-body" style="padding: 10px;">
								<p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}
								</p>
								<p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
								<p>3.{{$t("withdraw.with_tip")}}</p>
							</div>
							<template #reference @click="withdrawInfo()">
								<van-icon name="info-o" />
								{{$t("withdraw.limit_desc")}}
							</template>
						</van-popover>
					</div>

					<div class="balance">
						<span>{{$t("my.balance")}}：</span>
						<span class="number">{{ this.userInfo.money }}{{$t("reservation.unit")}}</span>
					</div>
				</div>
			</div>
			<!-- <div class="paypwd-box">
				<span>{{$t("setting.money_place")}}</span>
				<van-field v-model="paypassword" type="password" maxlength="6" :placeholder="$t('setting.money_place')" />
			</div> -->
			<van-button class="withdraw_btn" type="default" @click="doWithdraw()">
				{{$t("withdraw.immediately_withdraw")}}</van-button>

		</div>

		<van-popup v-model="showPayPwdPopup" :close-on-click-overlay="false" round position="center" :style="{ width: '80%' }">
			<div class="pwd-popup">
				<van-icon name="cross" class="pwd-close" @click="showPayPwdPopup = false" />
				<p class="pwd-title">{{$t("withdraw.set_paypwd_title")}}</p>
				<p class="pwd-tip">{{$t("withdraw.set_paypwd_tip")}}</p>
				<div class="pwd-item">
					<p class="pwd-label">{{$t("setting.money_place")}}</p>
					<van-field v-model="opw" type="password" maxlength="6" :placeholder="$t('setting.money_place')" />
				</div>
				<div class="pwd-item">
					<p class="pwd-label">{{$t("setting.money_again_place")}}</p>
					<van-field v-model="tpw" type="password" maxlength="6" :placeholder="$t('setting.money_again_place')" />
				</div>
				<van-button class="pwd-btn" type="default" @click="submitPayPassword()">{{$t("reservation.submit")}}</van-button>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showPopover: false,
				withdraw_money: "",
				userInfo: {},
				withdrawRole: {},
				showPayPwdPopup: false,
				opw: '',
				tpw: '',
				paypassword: ''
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						console.log('userInfo', this.userInfo)
						// this.name = res.data.name;
						if (Number(this.userInfo.paypassword) === 0) {
							// this.showPayPwdPopup = true;
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			submitPayPassword() {
				if (this.opw.length !== 6) {
					this.$toast(this.$t("setting.prefect"));
					return false;
				}
				if (this.tpw.length !== 6) {
					this.$toast(this.$t("setting.prefect"));
					return false;
				}
				if (this.opw !== this.tpw) {
					this.$toast(this.$t("setting.pwd_error"));
					return false;
				}
				this.$http({
					method: 'post',
					data: { paypassword: this.opw },
					url: 'user_set_paypw'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						this.showPayPwdPopup = false;
						this.opw = '';
						this.tpw = '';
						this.getUserInfo();
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserWithdrawRole() {
				this.$http({
					method: 'get',
					url: 'user_get_withdraw_role'
				}).then(res => {
					if (res.code === 200) {
						this.withdrawRole = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			allMoeny() {
				this.withdraw_money = this.userInfo.money;
			},
			doWithdraw() {
				// console.log('666', this.userInfo)
				// 禁止提现
				if (this.userInfo.num === 0) {
					this.$toast(this.$t("setting.withdrawals_prohibited"));
					return false;
				}
				if (this.withdraw_money <= 0) {
					this.$toast(this.$t("setting.correct_money"));
					return false;
				}

				// if (this.paypassword == '') {
				// 	this.$toast(this.$t("setting.prefect"));
				// 	return false;
				// }

				this.$http({
					method: 'post',
					data: {
						money: this.withdraw_money,
						paypassword: this.paypassword
					},
					url: 'user_set_withdraw'
				}).then(res => {
					if (res.code === 200) {
						location.reload()
						this.$toast(res.msg);
						this.getUserInfo();
						this.getUserWithdrawRole();
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
				
			},
			withdrawInfo() {
				this.showPopover = true;
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
				this.getUserWithdrawRole();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "@/assets/css/base";

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}

	.container p {
		padding: 0 15px;
		margin-top: 15px;
		font-size: 30px;
		color: #dc2037;
	}

	.container .main {
		display: flex;
		flex-direction: column;
		background-color: #f2f2f5;
		height: calc(100% - 50px);
		position: relative;
	}

	.container .main .withdrawMoney {
		display: flex;
		flex-direction: column;
		color: #000;
		padding: 0 20px;
		white-space: nowrap;
		font-size: 35px;
		background-color: #fff;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .money {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		border-bottom: 1px solid #f2f2f5;
	}

	.container .main .withdrawMoney .money .moneyNumber {
		font-size: 50px;
		display: flex;
		flex-direction: row;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .money .all {
		color: #d10404;
	}

	.container .main .withdrawMoney .money .moneyNumber .van-cell {
		font-size: 50px;
		padding: 0 !important;
	}

	.container .main .withdrawMoney .information {
		padding-bottom: 30px;
	}

	.container .main .withdrawMoney .information .description {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 10px 0;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .information .balance .number {
		color: #d10404;
	}

	.withdraw_btn {
		margin: 20px 30px 0;
		height: 80px;
		line-height: 1.22667rem;
		border-radius: 50px;
		color: #fff;
		font-size: 30px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(90deg, #988fba, #f487e0);
	}

	.paypwd-box {
		display: flex;
		flex-direction: column;
		padding: 0 20px;
		background-color: #fff;
		margin-top: 10px;
	}

	.paypwd-box span {
		padding: 10px 0;
		font-size: 35px;
		color: #000;
	}

	.paypwd-box .van-cell {
		font-size: 35px;
		padding: 10px 0;
		border-bottom: 1px solid #f2f2f5;
	}

	.pwd-popup {
		padding: 30px 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.pwd-popup .pwd-close {
		position: absolute;
		top: 15px;
		right: 15px;
		font-size: 35px;
		color: #969799;
	}

	.pwd-popup .pwd-title {
		font-size: 35px;
		font-weight: bold;
		color: #000;
		margin-bottom: 10px;
	}

	.pwd-popup .pwd-tip {
		font-size: 26px;
		color: #969799;
		margin-bottom: 20px;
		text-align: center;
	}

	.pwd-popup .pwd-item {
		width: 100%;
		margin-bottom: 20px;
	}

	.pwd-popup .pwd-item .pwd-label {
		font-size: 28px;
		color: #000;
		text-align: center;
		margin-bottom: 15px;
	}

	.pwd-popup .pwd-btn {
		margin-top: 20px;
		height: 80px;
		width: 80%;
		font-size: 30px;
		border-radius: 50px;
		color: #fff;
		border: none;
		background: linear-gradient(90deg, #988fba, #f487e0);
	}

	.pwd-popup .pwd-item .van-cell {
		border: 1px solid #dcdee2;
		border-radius: 10px;
		font-size: 30px;
	}
</style>